import React from "react";
import TabPanel from "../Reusable/Tab";
import EditBranch from "./EditBranch";
import BankDetails from "./BankDetails";
import Rate from "./Rate";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import Card from "../Reusable/Card";

const Switchtab = ({
  handleEdit,
  isLoading,
  branchData,
  id,
  bankData,
  handleIsEnableSMS,
  handleIsEnableEmail,
  handleIsActive,
}) => {
  return (
    <>
      <>
        <TabPanel
          tabTitle={["Update Branch", "Bank Details", "Rate", "Documents"]}
          tabPanels={[
            <>
              <EditBranch
                branchData={branchData}
                handleEdit={handleEdit}
                isLoading={isLoading}
                id={id}
                handleIsEnableSMS={handleIsEnableSMS}
                handleIsEnableEmail={handleIsEnableEmail}
                handleIsActive={handleIsActive}
              />
            </>,
            <>
              <BankDetails id={id} bankData={bankData} />
            </>,
            <>
              <Rate id={id} />
            </>,
            <>
              <FileUpload object_id={id} />
            </>,
          ]}
        />
      </>
    </>
  );
};

export default Switchtab;
